"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isContainer = exports.is = void 0;
var detector = function detector() {
  var _env = 'unknown';
  return {
    detect: function detect() {
      _env = window.self !== window.top ? 'iframe' : 'same-context';
      return _env;
    },
    isContainer: function isContainer() {
      return location.href.indexOf('__one-portal-container__') !== -1;
    }
  };
};
var env = detector();
var is = function is(name) {
  return env.detect() === name;
};
exports.is = is;
var isContainer = env.isContainer();
exports.isContainer = isContainer;